import React, { useRef, useEffect, useState } from 'react'
import './customization-select-bus-stop.css'
import triangleSortUp from '../../images/triangle_sort_up.png'
// import IndividualStationSelection from '../AddStationsFiles/IndividualStationSelection'
import IndividualBusStopSelection from './IndividualBusStopSelection'
import {v4 as uuidV4} from 'uuid'

export default function CustomizationSelectBusStop({routeBusStopsData}) {
  const [currentListOfStops, setCurrentListOfStops] = useState([])
  const [currentBusStopDirection, setCurrentBusStopDirection] = useState(1)

  useEffect(() => {
    setCurrentListOfStops(routeBusStopsData[0].stopsList)
    document.getElementById('customization-first-bus-stop-direction').style.borderBottom = '1px solid white'
  }, [])

  function clickFirstBusStopDirection() {
    setCurrentListOfStops(routeBusStopsData[0].stopsList)
    document.getElementById('customization-first-bus-stop-direction').style.borderBottom = '1px solid white'
    document.getElementById('customization-second-bus-stop-direction').style.borderBottom = '0px'
  }

  function clickSecondBusStopDirection() {
    setCurrentListOfStops(routeBusStopsData[1].stopsList)
    document.getElementById('customization-first-bus-stop-direction').style.borderBottom = '0px'
    document.getElementById('customization-second-bus-stop-direction').style.borderBottom = '1px solid white'
  }
 
  return (
    <div className='customization-select-bus-stop-container'>
      <div className='customization-select-bus-stop-direction-container'>
        <div id='customization-first-bus-stop-direction' className='customization-select-bus-stop-direction' onClick={clickFirstBusStopDirection}>
          North
        </div>
        <div id='customization-second-bus-stop-direction' className='customization-select-bus-stop-direction' onClick={clickSecondBusStopDirection}>
          South
        </div>
      </div>
      <div className='customization-select-bus-stop-search-and-sort-container'>
        <input placeholder='Station name' className='customization-select-bus-stop-search-container' />
        <div className='customization-select-bus-stop-sort-container'>
          <div className='customization-select-bus-stop-sort-text'>
            Sort
          </div>
          <img src={triangleSortUp} className='customization-select-bus-stop-sort-icon'/>
        </div>
      </div>
      {/* <div className='temp-line'></div> */}
      <div className='customization-select-bus-stop-all-stations-scroll-container'>
        <div className='customization-select-bus-stop-all-stations-container'>
          {currentListOfStops.map(stop => <IndividualBusStopSelection 
            // addTrainStationToList={addTrainStationToList} 
            stopName={stop.stopName} 
            stopId={stop.stopId} 
            lineColor={"red"} 
            lineColorHex={"#000000"}
            key={uuidV4()}/>
          )} 
        </div>
      </div>
    </div>
  )
}
